import { render } from "./Officer.vue?vue&type=template&id=547a3105&ts=true"
import script from "./Officer.vue?vue&type=script&lang=ts"
export * from "./Officer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../ss/AZ/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__